var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyId(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.54427 10.0833C8.54427 9.02477 9.40239 8.16665 10.4609 8.16665H18.1276C19.1861 8.16665 20.0443 9.02477 20.0443 10.0833V17.75C20.0443 18.8085 19.1861 19.6666 18.1276 19.6666H10.4609C9.40239 19.6666 8.54427 18.8085 8.54427 17.75V10.0833Z",
    fill: "#63DAA5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.54427 15.8333H6.6276C5.56906 15.8333 4.71094 14.9752 4.71094 13.9166V6.24998C4.71094 5.19143 5.56906 4.33331 6.6276 4.33331H14.2943C15.3528 4.33331 16.2109 5.19143 16.2109 6.24998V8.16665M10.4609 19.6666H18.1276C19.1861 19.6666 20.0443 18.8085 20.0443 17.75V10.0833C20.0443 9.02477 19.1861 8.16665 18.1276 8.16665H10.4609C9.40239 8.16665 8.54427 9.02477 8.54427 10.0833V17.75C8.54427 18.8085 9.40239 19.6666 10.4609 19.6666Z",
    stroke: "#202E3D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyId);
export default __webpack_public_path__ + "static/media/copyId.7632d20075d715bfce39c08ab1112aeb.svg";
export { ForwardRef as ReactComponent };